import { FC, useState } from "react";

import { Box, HStack } from "@chakra-ui/react";

import { Divider, FullWidthVStack } from "@components/common";
import { Desktop, Mobile } from "@lib/media";
import responsiveStyle from "@lib/theme/responsiveStyle";

import { OrderStep } from "../../constants";
import useCommonOrderSideEffects from "../../hooks/common/useCommonOrderSideEffects";
import useShipmentSideEffects from "../../hooks/shipment/useShipmentSideEffects";
import OrderFooter from "../common/OrderFooter";
import OrderForm from "../common/OrderForm";
import OrderPrice from "../common/OrderPrice";
import LockerSelectMap from "./LockerSelectMap";
import LockerSelectMapModal from "./LockerSelectMapModal";
import ShipmentFormFields from "./ShipmentFormFields";

const Shipment: FC = () => {
  useCommonOrderSideEffects(OrderStep.ShipmentDetails);
  useShipmentSideEffects();

  const [isMobileLockersMapVisible, setIsMobileLockersMapVisible] = useState(false);

  return (
    <OrderForm style={{ height: "100%" }}>
      <FullWidthVStack spacing={responsiveStyle({ mobile: "1.625rem", desktop: "2.25rem" })} height="100%">
        <FullWidthVStack spacing={responsiveStyle({ mobile: "1.625rem", desktop: "2.25rem" })} flex="1">
          <HStack align="flex-start" spacing="1rem">
            <Box width={responsiveStyle({ mobile: "100%", desktop: "50%" })}>
              <ShipmentFormFields onOpenLockersMap={() => setIsMobileLockersMapVisible(true)} />
            </Box>
            <Desktop>
              {(className, renderChildren) => (
                <Box flex="1" className={className}>
                  {renderChildren ? <LockerSelectMap /> : null}
                </Box>
              )}
            </Desktop>
          </HStack>
          <Divider />
          <OrderPrice withPromo={false} />
        </FullWidthVStack>
        <OrderFooter currentStep={OrderStep.ShipmentDetails} />
      </FullWidthVStack>
      <Mobile>
        {isMobileLockersMapVisible && <LockerSelectMapModal onClose={() => setIsMobileLockersMapVisible(false)} />}
      </Mobile>
    </OrderForm>
  );
};
export default Shipment;
